export default __webpack_public_path__ + "maps-examples-clustering-with-images-thumbnail-480-52c5a369b137b67d11cbc07cb243e907.webp";